export const shopifyStoreStructuredDataMixin = {
    computed: {
        store_structured_data: function () {
            if(!this.store){
                return;
            }
            var name = this.store.name;
            if (name && name.length > 150) {
                name = name.slice(0, 150);
            }
            name = this.processStructuredDataText(name);
            
            var description = this.store.description || name;
            description = this.processStructuredDataText(description);
            
            var data = {
                '@context': 'https://schema.org/',
                '@type': 'Organization',
                'identifier': {
                    "@type": "PropertyValue",
                    propertyID: 'Shopify ID',
                    value: this.store.id.toString()
                },
                name: name,
                description: description
            };
            
            if (this.store.profile_url) {
                data.url = this.store.profile_url;
            }
            
            if (this.store.email) {
                data.email = this.store.email;
            }
            if (this.store.phone) {
                //Validate that the value is a phone number
                var match = this.store.phone.match(/\d/g);
                var is_valid_phone = match && match.length >= 8;
                if(is_valid_phone){
                    data.telephone = this.store.phone;
                }
            }
            if (this.store.logo) {
                data.logo = this.store.logo;
            }
            
            var urls = [];
            if(this.store.myshopify_domain){
                urls.push('https://' + this.store.myshopify_domain);
            }
            if(this.store.domain){
                urls.push('https://' + this.store.domain);
            }
            if(this.store.social_urls && this.store.social_urls.length){
                for(var i=0; i < this.store.social_urls.length; i++){
                    var url = this.store.social_urls[i];
                    
                    if(url[0] === '/'){
                        //Add the store's domain to a relative url
                        var domain = this.store.domain || this.store.myshopify_domain;
                        if(domain){
                            url = 'https://' + domain + url;
                        }
                    }
                    
                    if(url.indexOf('http') === 0){
                        urls.push(url);
                    }
                }
            }
            data.sameAs = urls;
            
            if(this.store._cover_images && this.store._cover_images.length){
                data.image = this.store._cover_images;
            }
            
            var keywords = [];
            if(this.store.category_summary && this.store.category_summary.length){
                var categories = this.store.category_summary.slice(0, 5).map(function(category){
                    return category.name;
                });
                keywords = keywords.concat(categories);
            }
            if(this.store._keywords && this.store._keywords.length){
                keywords = keywords.concat(this.store._keywords);
            }
            if(keywords.length){
                data.keywords = keywords;
            }
            
            if(this.store.min_price && this.store.max_price){
                data.priceRange = this.formatCurrency(this.store.min_price) + ' - ' + this.formatCurrency(this.store.max_price);
            }
            
            if(this.store.shopify_pay_enabled_card_brands && this.store.shopify_pay_enabled_card_brands.length){
                data.paymentAccepted = 'Credit Card';
            }
            if(this.store.currency){
                data.currenciesAccepted	= this.store.currency;
            }
            
            var address = {
                '@type': 'PostalAddress'
            };
            if (this.store.city) {
                address.addressLocality = this.store.city;
            }
            if (this.store.province) {
                address.addressRegion = this.store.province;
            }
            if (this.store.country) {
                address.addressCountry = this.store.country;
            }
            data.address = address;
           
            return data;
        },
    },
    methods: {
        processStructuredDataText: function(text){
            if(typeof text === 'string'){
                text = text.replace(/"/g, '\''); //replace double quotes with single
                text = text.replace(/\//g, ' '); //replace forward slashes with a space
                text = text.replace(/[\\\/\"]/g, ''); //remove slashes and double quotes
            }
            return text;
        },
        formatCurrency: function(unit_amount){
            var num = unit_amount / 100; //convert to dollars
            num = num.toLocaleString('en-US', {
                style: 'currency',
                currency:'USD',
                maximumFractionDigits: 2,
                minimumFractionDigits: 2
            });
            return num;
        },
    }
}


// WEBPACK FOOTER //
// ./resources/views/rd/assets/js/v2/mixins/shopify/shopifyStoreStructuredDataMixin.js